type LogContext = Record<string, unknown>;

// Use a function declaration instead of const to avoid hoisting issues
function formatContext(context?: LogContext): LogContext | undefined {
	if (!context) {
		return undefined;
	}
	const keys = Object.keys(context);
	if (keys.length === 0) {
		return undefined;
	}
	return context;
}

// Define prefix as a const outside the class to avoid static property initialization issues
const LOGGER_PREFIX = "[Front]";

export class LoggerService {
	private static get prefix(): string {
		return LOGGER_PREFIX;
	}

	public static debug(_message: string, _context?: LogContext): void {
		// console.debug(`${LoggerService.prefix} ${message}`, formatContext(context));
	}

	public static info(message: string, context?: LogContext): void {
		const formattedContext = formatContext(context);
		if (formattedContext === undefined) {
			console.info(`${LoggerService.prefix} ${message}`);
			return;
		}
		console.info(`${LoggerService.prefix} ${message}`, formattedContext);
	}

	public static warn(message: string, context?: LogContext): void {
		const formattedContext = formatContext(context);
		if (formattedContext === undefined) {
			console.warn(`${LoggerService.prefix} ${message}`);
			return;
		}
		console.warn(`${LoggerService.prefix} ${message}`, formattedContext);
	}

	public static error(message: string, context?: LogContext): void {
		const formattedContext = formatContext(context);
		if (formattedContext === undefined) {
			console.error(`${LoggerService.prefix} ${message}`);
			return;
		}
		// Si le contexte contient un objet Error, extraire ses propriétés
		if (typeof formattedContext === "object") {
			const errorKeys = Object.keys(formattedContext);
			if (errorKeys.some((key) => formattedContext[key] instanceof Error)) {
				const enhancedContext: LogContext = {};
				for (const [key, value] of Object.entries(formattedContext)) {
					if (value instanceof Error) {
						enhancedContext[key] = {
							name: value.name,
							message: value.message,
							stack: value.stack?.split("\n").slice(0, 5).join("\n"),
						};
					} else {
						enhancedContext[key] = value;
					}
				}
				console.error(`${LoggerService.prefix} ${message}`, enhancedContext);
				return;
			}
		}
		console.error(`${LoggerService.prefix} ${message}`, formattedContext);
	}
}
